/**
 * Engine types. The prose version of this file is docs/specs/data-model.md;
 * keep the two in step.
 *
 * Everything here is plain data: JSON-serialisable, no classes, no methods.
 * The engine never mutates a state object it was given; every function that
 * changes state returns a new one.
 */
export const COLORS = ['yellow', 'orange', 'green', 'white', 'pink', 'blue'];
export const ACTIONS = [
    'forum',
    'military',
    'trajan',
    'seaport',
    'senate',
    'construction',
];
export const TRAY_COUNT = 6;
/** Two markers of each of six colours, spread over six trays. */
export const MARKERS_PER_TRAY = 2;
//# sourceMappingURL=types.js.map